import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { companyTypeSchema } from '../../../schemas/company-type.schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { companyInfoSchema } from '../schemas/company-info.schema';
import { companySchema } from '../schemas/company.schema';

/**
 * Get a company's details by its externalId
 * @param externalId Company's ExternalId
 * @returns Company Details
 */
export function getCompanyExternalId(this: unknown, externalId: string) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          accountsEnvironment.resolve(this).companyUrl
        }/externalid/${encodeURIComponent(externalId)}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      companySchema
        .omit({
          externalAccountId: true,
          products: true,
          purchaseOrderHistory: true,
        })
        .extend({
          name: z.string().nullable(),
          alias: z.string().nullable(),
          accountType: companyTypeSchema.nullable(),
          companyInfo: companyInfoSchema.nullable(),
        })
    )
  );
}
